/**
 * De nagebootste betaalpagina van de testmodus zonder Mollie-sleutel. Ziet er
 * met opzet níet uit als Mollie.
 */

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../api';
import { Euro, Knop, Laden, Melding, useTitel } from '../componenten/basis';
import { Pagina } from '../componenten/Schil';

interface Nepbetaling {
  id: string;
  bedragCent: number;
  status: string;
  omschrijving: string;
  klantnaam: string | null;
}

export function NepMollie() {
  useTitel('Nep-Mollie');
  const { id = '' } = useParams();
  const [b, zetB] = useState<Nepbetaling | null>(null);
  const [fout, zetFout] = useState<string | null>(null);
  const [bezig, zetBezig] = useState(false);

  useEffect(() => {
    api.haal<Nepbetaling>(`/api/nepmollie/${id}`).then(zetB).catch((f: Error) => zetFout(f.message));
  }, [id]);

  async function beslis(uitkomst: 'paid' | 'failed' | 'canceled') {
    zetBezig(true);
    try {
      const uit = await api.stuur<{ naar: string }>(`/api/nepmollie/${id}`, { uitkomst });
      window.location.href = uit.naar;
    } catch (f) {
      zetFout((f as Error).message);
      zetBezig(false);
    }
  }

  return (
    <Pagina smal>
      <div className="py-16">
        <div className="mx-auto max-w-md rounded-2xl border-2 border-dashed border-test/50 bg-test/5 p-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-test">Testmodus · nagebootste bank</p>
          {fout && <Melding soort="fout">{fout}</Melding>}
          {!b && !fout && <Laden />}
          {b && (
            <>
              <h1 className="mt-3 text-2xl">
                {b.omschrijving}
              </h1>
              <p className="mt-1 text-inkt-zacht">{b.klantnaam}</p>
              <p className="mt-4 font-display text-4xl text-goud-300">
                <Euro cent={b.bedragCent} />
              </p>
              {b.status !== 'open' ? (
                <p className="mt-6 text-sm text-inkt-zacht">Deze betaling is al beslist: {b.status}.</p>
              ) : (
                <div className="mt-8 flex flex-wrap gap-3">
                  <Knop onClick={() => beslis('paid')} bezig={bezig}>
                    Betaald
                  </Knop>
                  <Knop soort="stil" onClick={() => beslis('failed')} bezig={bezig}>
                    Mislukt
                  </Knop>
                  <Knop soort="stil" onClick={() => beslis('canceled')} bezig={bezig}>
                    Afgebroken
                  </Knop>
                </div>
              )}
              <p className="mt-6 text-xs text-inkt-stil">
                Hier zou normaal de bankkeuze van Mollie staan. Zonder Mollie-sleutel beslis je hier zelf hoe de betaling afloopt.
              </p>
            </>
          )}
        </div>
      </div>
    </Pagina>
  );
}
